import React from "react";
import { BridgeSelector } from "../components/core/BridgeSelector";

/**
 * Step 5: Install Bridge
 * Allows users to select and configure the ship's bridge
 * according to Traveller rules and requirements
 *
 * @component
 * @example
 * ```tsx
 * <BridgeStep />
 * ```
 */
export const BridgeStep: React.FC = () => {
  return (
    <div className="pb-32">
      <BridgeSelector />
    </div>
  );
};
